// this file is automatically generated by git.revision.js script
export const versions = { revision: '0d684d594a' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '0d684d594a';
